export default function SchemaOrg({ type, data }: { type: string; data: Record<string, unknown> }) {
  const schema = { '@context': 'https://schema.org', '@type': type, ...data };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}